import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_ZOHO } from './constants';
import { verifyZoho } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { readToken } from 'utils/readToken';

export function* saveZohoCode({ payload }) {
  const token = readToken();
  try {
    yield call(request, {
      method: 'post',
      endpoint: 'app/integration/zoho',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });
    triggerNotification({
      title: 'Zoho integrated successfully!',
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyZoho.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyZoho.error(errorMessage));
  }
}

export default function* zohoVerify() {
  yield takeLatest(VERIFY_ZOHO.START, saveZohoCode);
}
